import { searchActors, getActorMovieIds } from '../api/tmdb'
import { db } from '../firebase'
import { doc, getDoc, getDocs, collection, query, orderBy, limit, documentId, runTransaction, serverTimestamp } from 'firebase/firestore'

export const ACTOR_POOL = [
  { name: 'Tom Hanks', gender: 'male' },
  { name: 'Meryl Streep', gender: 'female' },
  { name: 'Denzel Washington', gender: 'male' },
  { name: 'Cate Blanchett', gender: 'female' },
  { name: 'Leonardo DiCaprio', gender: 'male' },
  { name: 'Julia Roberts', gender: 'female' },
  { name: 'Brad Pitt', gender: 'male' },
  { name: 'Natalie Portman', gender: 'female' },
  { name: 'Matt Damon', gender: 'male' },
  { name: 'Charlize Theron', gender: 'female' },
  { name: 'Tom Cruise', gender: 'male' },
  { name: 'Viola Davis', gender: 'female' },
  { name: 'Will Smith', gender: 'male' },
  { name: 'Amy Adams', gender: 'female' },
  { name: 'Robert De Niro', gender: 'male' },
  { name: 'Sandra Bullock', gender: 'female' },
  { name: 'Johnny Depp', gender: 'male' },
  { name: 'Halle Berry', gender: 'female' },
  { name: 'George Clooney', gender: 'male' },
  { name: 'Reese Witherspoon', gender: 'female' },
  { name: 'Christian Bale', gender: 'male' },
  { name: 'Julianne Moore', gender: 'female' },
  { name: 'Ryan Gosling', gender: 'male' },
  { name: 'Emma Stone', gender: 'female' },
  { name: 'Joaquin Phoenix', gender: 'male' },
  { name: 'Nicole Kidman', gender: 'female' },
  { name: 'Benedict Cumberbatch', gender: 'male' },
  { name: "Lupita Nyong'o", gender: 'female' },
  { name: 'Jamie Foxx', gender: 'male' },
  { name: 'Jessica Chastain', gender: 'female' },
  { name: 'Liam Neeson', gender: 'male' },
  { name: 'Keira Knightley', gender: 'female' },
  { name: 'Michael Fassbender', gender: 'male' },
  { name: 'Margot Robbie', gender: 'female' },
  { name: 'Ethan Hawke', gender: 'male' },
  { name: 'Rachel McAdams', gender: 'female' },
  { name: 'Jeff Bridges', gender: 'male' },
  { name: 'Taraji P. Henson', gender: 'female' },
  { name: 'Anthony Hopkins', gender: 'male' },
  { name: 'Brie Larson', gender: 'female' },
  { name: 'Daniel Craig', gender: 'male' },
  { name: 'Zoe Saldana', gender: 'female' },
  { name: 'Hugh Jackman', gender: 'male' },
  { name: 'Penélope Cruz', gender: 'female' },
  { name: 'Mark Ruffalo', gender: 'male' },
  { name: 'Scarlett Johansson', gender: 'female' },
  { name: 'Jake Gyllenhaal', gender: 'male' },
  { name: 'Tilda Swinton', gender: 'female' },
  { name: 'Ryan Reynolds', gender: 'male' },
  { name: 'Kate Winslet', gender: 'female' },
  { name: 'Chris Pratt', gender: 'male' },
  { name: 'Judi Dench', gender: 'female' },
  { name: 'Michael B. Jordan', gender: 'male' },
  { name: 'Helena Bonham Carter', gender: 'female' },
  { name: 'Steve Carell', gender: 'male' },
  { name: 'Kerry Washington', gender: 'female' },
  { name: 'Daniel Day-Lewis', gender: 'male' },
  { name: 'Idris Elba', gender: 'male' },
  { name: 'Timothée Chalamet', gender: 'male' },
  { name: 'Awkwafina', gender: 'female' },
  // Female additions
  { name: 'Angelina Jolie', gender: 'female' },
  { name: 'Jennifer Lawrence', gender: 'female' },
  { name: 'Zendaya', gender: 'female' },
  { name: 'Salma Hayek', gender: 'female' },
  { name: 'Cameron Diaz', gender: 'female' },
  { name: 'Alicia Vikander', gender: 'female' },
  { name: 'Saoirse Ronan', gender: 'female' },
  { name: 'Florence Pugh', gender: 'female' },
  { name: 'Ana de Armas', gender: 'female' },
  { name: 'Jennifer Aniston', gender: 'female' },
  { name: 'Halle Bailey', gender: 'female' },
  { name: 'Sydney Sweeney', gender: 'female' },
  { name: 'Anya Taylor-Joy', gender: 'female' },
  { name: 'Jessica Alba', gender: 'female' },
  { name: 'Octavia Spencer', gender: 'female' },
  { name: 'Whoopi Goldberg', gender: 'female' },
  { name: 'Sharon Stone', gender: 'female' },
  { name: 'Sigourney Weaver', gender: 'female' },
  { name: 'Demi Moore', gender: 'female' },
  { name: 'Michelle Pfeiffer', gender: 'female' },
  { name: 'Susan Sarandon', gender: 'female' },
  { name: 'Naomi Watts', gender: 'female' },
  { name: 'Eva Mendes', gender: 'female' },
  { name: 'Gabrielle Union', gender: 'female' },
  { name: 'Regina King', gender: 'female' },
  { name: 'Janelle Monáe', gender: 'female' },
  { name: 'Mary J. Blige', gender: 'female' },
  { name: 'Queen Latifah', gender: 'female' },
  { name: 'Michelle Rodriguez', gender: 'female' },
  // Male additions
  { name: 'Pedro Pascal', gender: 'male' },
  { name: 'Oscar Isaac', gender: 'male' },
  { name: 'Adam Driver', gender: 'male' },
  { name: 'Mahershala Ali', gender: 'male' },
  { name: 'Anthony Mackie', gender: 'male' },
  { name: 'Dev Patel', gender: 'male' },
  { name: 'Vin Diesel', gender: 'male' },
  { name: 'Samuel L. Jackson', gender: 'male' },
  { name: 'Chris Evans', gender: 'male' },
  { name: 'Chris Hemsworth', gender: 'male' },
  { name: 'Robert Downey Jr.', gender: 'male' },
  { name: 'Keanu Reeves', gender: 'male' },
  { name: 'Dwayne Johnson', gender: 'male' },
  { name: 'Jason Statham', gender: 'male' },
  { name: 'Mark Wahlberg', gender: 'male' },
  { name: 'Javier Bardem', gender: 'male' },
  { name: 'Antonio Banderas', gender: 'male' },
  { name: 'Morgan Freeman', gender: 'male' },
  { name: 'Laurence Fishburne', gender: 'male' },
  { name: 'Wesley Snipes', gender: 'male' },
  { name: 'Eddie Murphy', gender: 'male' },
  { name: 'Kevin Hart', gender: 'male' },
  { name: 'Ice Cube', gender: 'male' },
  { name: 'John Boyega', gender: 'male' },
  { name: 'Chadwick Boseman', gender: 'male' },
  { name: 'Jeffrey Wright', gender: 'male' },
  { name: 'Aldis Hodge', gender: 'male' },
]

export const LAUNCH_DATE = '2026-04-16'

// Multi-date cache — object keyed by date string
const CACHE_KEY = 'action_puzzle_cache'

export function getPuzzleNumber(date) {
  const launch = new Date(LAUNCH_DATE + 'T00:00:00')
  const current = new Date(date + 'T00:00:00')
  return Math.max(1, Math.floor((current - launch) / 86400000) + 1)
}

function dateToSeed(dateStr) {
  let h = 5381
  for (let i = 0; i < dateStr.length; i++) {
    h = (((h << 5) + h) ^ dateStr.charCodeAt(i)) >>> 0
  }
  // Avalanche finalizer (murmur3 fmix32). Without it, consecutive dates — which
  // differ only in the last digit on most days — hash to near-sequential seeds,
  // and mulberry32's FIRST output barely changes for adjacent seeds. That made
  // dates a step apart land on the same pool index, which folded the daily chain
  // back into a reversed pair (A→B one day, B→A the next). fmix32 fully
  // decorrelates near-identical date strings while staying deterministic.
  h = (h ^ (h >>> 16)) >>> 0
  h = Math.imul(h, 0x85ebca6b) >>> 0
  h = (h ^ (h >>> 13)) >>> 0
  h = Math.imul(h, 0xc2b2ae35) >>> 0
  h = (h ^ (h >>> 16)) >>> 0
  return h || 1
}

function mulberry32(seed) {
  let s = seed >>> 0
  return () => {
    s = (s + 0x6D2B79F5) >>> 0
    let t = Math.imul(s ^ (s >>> 15), 1 | s)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

function getCachedPair(date) {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (data.date === date) return data         // old single-entry format
    return data[date] ?? null                   // new object format
  } catch { return null }
}

function setCachedPair(date, startActor, endActor) {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    let cache = {}
    try {
      const parsed = JSON.parse(raw || '{}')
      cache = typeof parsed.date === 'string' ? {} : parsed
    } catch { cache = {} }
    cache[date] = { date, startActor, endActor }
    const keys = Object.keys(cache).sort()
    if (keys.length > 30) keys.slice(0, keys.length - 30).forEach(k => delete cache[k])
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache))
  } catch {}
}

async function findActor(name) {
  try {
    const results = await searchActors(name)
    return results.find(r => r.name.toLowerCase() === name.toLowerCase()) || results[0] || null
  } catch { return null }
}

// ── Firestore helpers ───────────────────────────────────────

function chainDocRef(dateStr) {
  return doc(db, 'dailyChain', dateStr)
}

function getYesterdayDateStr(dateStr) {
  const d = new Date(dateStr + 'T00:00:00')
  d.setDate(d.getDate() - 1)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** Compact actor shape for Firestore storage. */
function actorDoc(actor) {
  return { id: actor.id, name: actor.name, profile_path: actor.profile_path ?? null }
}

/**
 * Check whether two actors share at least one movie (direct co-stars).
 * Returns true if they are co-stars and should NOT be paired.
 */
async function areDirectCoStars(actorAId, actorBId) {
  try {
    const [moviesA, moviesB] = await Promise.all([
      getActorMovieIds(actorAId),
      getActorMovieIds(actorBId),
    ])
    for (const mid of moviesA) {
      if (moviesB.has(mid)) return true
    }
    return false
  } catch {
    return false // if we can't check, allow the pair
  }
}

// ── Deck-of-cards + variety state ───────────────────────────
// NOTE: the deck is keyed by actor NAME, not TMDB id. ACTOR_POOL has only
// { name, gender } (no ids) and stored dailyChain docs carry no gender, so the
// pool name is the one key that lets us (a) cheaply pre-filter the pool by
// "used/recent" without resolving 116 names against TMDB every day, and
// (b) look up gender for the consecutive-gender cap. (The fix prompt's schema
// used `usedActorIds`/`recentGoalIds`; renamed to *Names for this reason.)

function deckStateRef() {
  return doc(db, 'dailyChain', '_deckState')
}

/** Gender shared by the last 3 goals, or null if mixed / <3 / unknown. */
function genderCapFromRecent(recentGoalNames = []) {
  if (recentGoalNames.length < 3) return null
  const last3 = recentGoalNames.slice(-3)
  const genders = last3.map((n) => {
    const entry = ACTOR_POOL.find((a) => a.name.toLowerCase() === String(n).toLowerCase())
    return entry?.gender ?? null
  })
  if (genders.some((g) => g == null)) return null
  return genders.every((g) => g === genders[0]) ? genders[0] : null
}

/**
 * Read the global deck state, or initialize it from recent history on first run.
 * Init seeds `recentGoalNames` from the last ~3 dailyChain pairs so freshly-used
 * actors are excluded immediately; `usedActorNames` starts empty (new cycle today).
 */
async function readOrInitDeckState(dateStr) {
  try {
    const snap = await getDoc(deckStateRef())
    if (snap.exists()) {
      const d = snap.data()
      return {
        usedActorNames: Array.isArray(d.usedActorNames) ? d.usedActorNames : [],
        recentGoalNames: Array.isArray(d.recentGoalNames) ? d.recentGoalNames : [],
        cycleStartDate: d.cycleStartDate || dateStr,
      }
    }
    // First run: seed from recent history so overused actors are locked out for
    // the rest of the cycle (not just 3 days). usedActorNames = unique goals across
    // the last ~10 days; recentGoalNames = last 3 goals (chronological).
    let used = []
    let recent = []
    try {
      // limit 11: "_deckState" sorts first under documentId desc ('_' > digits),
      // so fetch one extra and drop it to keep ~10 real date docs.
      const qs = await getDocs(
        query(collection(db, 'dailyChain'), orderBy(documentId(), 'desc'), limit(11)),
      )
      const names = [] // newest → oldest
      qs.forEach((docSnap) => {
        if (docSnap.id === '_deckState') return
        const goal = docSnap.data()?.endActor
        const name = goal?._poolName || goal?.name
        if (name) names.push(name)
      })
      const chronological = [...names].reverse() // oldest → newest
      recent = chronological.slice(-3)
      // Unique used set across the window, preserving chronological order.
      const seen = new Set()
      for (const n of chronological) {
        const key = n.toLowerCase()
        if (!seen.has(key)) { seen.add(key); used.push(n) }
      }
    } catch (e) {
      console.warn('[Marathon] Deck init history query failed:', e.message)
    }
    return { usedActorNames: used, recentGoalNames: recent, cycleStartDate: dateStr }
  } catch {
    return { usedActorNames: [], recentGoalNames: [], cycleStartDate: dateStr }
  }
}

/**
 * Produce the next deck state after picking `endActor`. Appends the goal to the
 * cycle's used set + the recent-3 window; resets the cycle (NOT recent) when the
 * deck is exhausted, which is what prevents same-week repeats across the boundary.
 */
function advanceDeck(baseDeck, endActor, dateStr) {
  const goalName = endActor._poolName || endActor.name
  const lower = goalName.toLowerCase()
  let used = Array.isArray(baseDeck?.usedActorNames) ? [...baseDeck.usedActorNames] : []
  let recent = Array.isArray(baseDeck?.recentGoalNames) ? [...baseDeck.recentGoalNames] : []
  let cycleStartDate = baseDeck?.cycleStartDate || dateStr

  if (!used.some((n) => String(n).toLowerCase() === lower)) used.push(goalName)
  recent.push(goalName)
  while (recent.length > 3) recent.shift()

  // Cycle complete → reset the used deck (recent persists across the boundary).
  if (used.length >= ACTOR_POOL.length) {
    return { usedActorNames: [], recentGoalNames: recent, cycleStartDate: dateStr }
  }
  return { usedActorNames: used, recentGoalNames: recent, cycleStartDate }
}

/**
 * Seeded co-star re-roll within a pre-filtered candidate list. Returns a resolved
 * non-co-star TMDB actor (tagged with `_poolName` for deck tracking), or null if
 * all MAX_ATTEMPTS rolls were blocked / co-stars / unresolvable.
 */
async function seededCoStarPick(candidates, rand, startActor, blockedIds) {
  const MAX_ATTEMPTS = 15
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
    const cand = candidates[Math.floor(rand() * candidates.length)]
    const resolved = await findActor(cand.name)
    if (!resolved) continue
    if (blockedIds.has(resolved.id)) continue
    if (await areDirectCoStars(startActor.id, resolved.id)) {
      console.log(`[Marathon] Re-rolling: ${resolved.name} is a direct co-star of ${startActor.name}`)
      continue
    }
    resolved._poolName = cand.name
    console.log(`[Marathon] Picked end actor: ${resolved.name} (attempt ${attempt + 1})`)
    return resolved
  }
  return null
}

/**
 * Pick an end actor for a given date using the seeded PRNG, applying the
 * deck-of-cards + gender-variety rules. Priority: solvability (non-co-star) >
 * deck (unused this cycle) > gender variety. Fallback ladder (best → worst):
 *   1. unused + opposite-gender (if a 3-in-a-row gender cap is active) + non-co-star
 *   2. unused + any gender + non-co-star            (gender relaxed)
 *   3. used-but-not-recent + non-co-star            (deck relaxed)
 *   4. existing last-resort: any non-recent candidate, even a co-star
 * `recentGoalNames` (last 3 goals) is ALWAYS hard-excluded from steps 1-4.
 * Returns a full TMDB actor object (tagged with `_poolName`).
 */
async function pickEndActor(startActor, dateStr, excludeActors = [], deckState = null) {
  const seed = dateToSeed(dateStr)
  const rand = mulberry32(seed)

  // Hard exclusions: the start actor + caller exclusions (e.g. yesterday's start).
  const blocked = [startActor, ...excludeActors].filter(Boolean)
  const blockedNames = new Set(blocked.map((a) => a.name.toLowerCase()))
  const blockedIds = new Set(blocked.map((a) => a.id))

  const used = new Set((deckState?.usedActorNames || []).map((s) => String(s).toLowerCase()))
  const recent = new Set((deckState?.recentGoalNames || []).map((s) => String(s).toLowerCase()))
  const genderCap = genderCapFromRecent(deckState?.recentGoalNames || [])

  // Name-based pre-filter (cheap, no TMDB). recent is ALWAYS excluded.
  const base = ACTOR_POOL.filter((a) => {
    const n = a.name.toLowerCase()
    return !blockedNames.has(n) && !recent.has(n)
  })
  const unused = base.filter((a) => !used.has(a.name.toLowerCase()))
  const unusedOpposite = genderCap ? unused.filter((a) => a.gender !== genderCap) : unused

  // Tiers, best → worst (dedupe identical array refs when no gender cap).
  const tiers = [unusedOpposite, unused, base].filter((t, i, arr) => arr.indexOf(t) === i)
  for (const tier of tiers) {
    if (!tier.length) continue
    const picked = await seededCoStarPick(tier, rand, startActor, blockedIds)
    if (picked) return picked
  }

  // 4. Last resort — take a candidate even if co-star (recent still excluded).
  const pool = base.length ? base : ACTOR_POOL
  const lastIdx = Math.floor(rand() * pool.length)
  const fallback = await findActor(pool[lastIdx].name)
  console.warn('[Marathon] Exhausted re-rolls, using fallback:', fallback?.name)
  if (fallback) fallback._poolName = pool[lastIdx].name
  return fallback
}

// ── Legacy system (used as fallback for pre-chain dates) ────

/**
 * Original seeded-random puzzle generation — no Firestore, no chain.
 * Used as fallback when no Firestore doc exists for a date (pre-chain days).
 */
export async function getLegacyPuzzleForDate(date) {
  const cached = getCachedPair(date)
  if (cached) {
    console.log(`[Action!] Date: ${date} (cached) → ${cached.startActor.name} / ${cached.endActor.name}`)
    return cached
  }

  const seed = dateToSeed(date)
  const rand = mulberry32(seed)
  const N = ACTOR_POOL.length

  const idxA = Math.floor(rand() * N)
  const idxB = (idxA + 1 + Math.floor(rand() * (N - 1))) % N

  const [actorA, actorB] = await Promise.all([
    findActor(ACTOR_POOL[idxA].name),
    findActor(ACTOR_POOL[idxB].name),
  ])

  if (!actorA || !actorB) {
    throw new Error(`Could not resolve actors for ${date}`)
  }

  console.log(`[Action!] Date: ${date} (legacy), idxA: ${idxA} (${actorA.name}), idxB: ${idxB} (${actorB.name})`)

  setCachedPair(date, actorA, actorB)
  return { date, startActor: actorA, endActor: actorB }
}

// ── Marathon Daily chain system ─────────────────────────────

/**
 * Get (or generate) the puzzle for a given date using the Marathon chain.
 *
 * 1. Check localStorage cache
 * 2. Check Firestore dailyChain collection
 * 3. Generate: yesterday's endActor → today's startActor, pick endActor via seeded PRNG
 * 4. Write to Firestore (first writer wins via transaction)
 *
 * Falls back to the legacy seeded system if yesterday has no Firestore doc
 * (pre-chain dates or gaps).
 */
export async function getChainPuzzleForDate(dateStr) {
  // 1. Fast path — localStorage cache
  const cached = getCachedPair(dateStr)
  if (cached) {
    console.log(`[Marathon] Date: ${dateStr} (cached) → ${cached.startActor.name} / ${cached.endActor.name}`)
    return cached
  }

  try {
    // 2. Check Firestore
    const snap = await getDoc(chainDocRef(dateStr))
    if (snap.exists()) {
      const data = snap.data()
      console.log(`[Marathon] Date: ${dateStr} (Firestore) → ${data.startActor.name} / ${data.endActor.name}`)
      setCachedPair(dateStr, data.startActor, data.endActor)
      return { date: dateStr, startActor: data.startActor, endActor: data.endActor }
    }

    // 3. Generate — need yesterday's endActor as today's startActor
    const yesterdayStr = getYesterdayDateStr(dateStr)
    const yesterdaySnap = await getDoc(chainDocRef(yesterdayStr))

    // Deck-of-cards + recent/gender state (read existing, or seed from history).
    const deckState = await readOrInitDeckState(dateStr)

    let startActor, endActor

    if (yesterdaySnap.exists()) {
      // Chain continues: yesterday's endActor → today's startActor
      const yData = yesterdaySnap.data()
      startActor = yData.endActor
      console.log(`[Marathon] Chaining from yesterday's end actor: ${startActor.name}`)
      // Exclude yesterday's START so the chain can't fold straight back into a
      // reversed pair (yesterday A→B must never become today B→A).
      endActor = await pickEndActor(startActor, dateStr, [yData.startActor], deckState)
    } else {
      // No yesterday doc — bootstrap the chain. Seed the START from the date PRNG
      // (as the legacy system did) but pick the GOAL through the deck-aware picker
      // so a chain gap can't bypass the deck / recent-goal / gender rules.
      console.log(`[Marathon] No yesterday doc for ${yesterdayStr}, bootstrapping (deck-aware goal)`)
      const seed = dateToSeed(dateStr)
      const rand = mulberry32(seed)
      const idxA = Math.floor(rand() * ACTOR_POOL.length)
      startActor = await findActor(ACTOR_POOL[idxA].name)
      if (startActor) endActor = await pickEndActor(startActor, dateStr, [], deckState)
    }

    if (!startActor || !endActor) {
      throw new Error(`Could not resolve actors for ${dateStr}`)
    }

    // 4. Write today's pair AND advance the deck in the SAME transaction — first
    //    writer wins; if two clients race the same date, only one commits both.
    const result = await runTransaction(db, async (tx) => {
      const txSnap = await tx.get(chainDocRef(dateStr))
      if (txSnap.exists()) {
        // Another client wrote first — use their data (they advanced the deck).
        return txSnap.data()
      }
      // Re-read the deck inside the tx so the ledger update can't be lost.
      const deckSnap = await tx.get(deckStateRef())
      const baseDeck = deckSnap.exists() ? deckSnap.data() : deckState
      const newDoc = {
        startActor: actorDoc(startActor),
        endActor: actorDoc(endActor),
        dailyNumber: getPuzzleNumber(dateStr),
        generatedAt: serverTimestamp(),
      }
      tx.set(chainDocRef(dateStr), newDoc)
      tx.set(deckStateRef(), advanceDeck(baseDeck, endActor, dateStr))
      console.log(`[Marathon] Wrote dailyChain doc for ${dateStr}: ${startActor.name} → ${endActor.name}`)
      return newDoc
    })

    setCachedPair(dateStr, result.startActor, result.endActor)
    return { date: dateStr, startActor: result.startActor, endActor: result.endActor }

  } catch (err) {
    // Network failure — fall back to legacy so the game remains playable offline
    console.warn('[Marathon] Firestore unavailable, falling back to legacy:', err.message)
    return getLegacyPuzzleForDate(dateStr)
  }
}

// ── Public API (same signatures as before) ──────────────────

export async function getPuzzleForDate(date) {
  return getChainPuzzleForDate(date)
}

export function getLocalDateStr() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export async function getOrGenerateTodaysPuzzle() {
  return getChainPuzzleForDate(getLocalDateStr())
}

/**
 * Synchronous actor-name preview for the HomeScreen.
 * Checks localStorage cache first (populated after first load of the day).
 * Falls back to legacy PRNG names if cache is cold (brief flash before async resolves).
 */
export function getDailyActorNames(dateStr) {
  const date = dateStr || getLocalDateStr()
  const cached = getCachedPair(date)
  if (cached) {
    return { startName: cached.startActor.name, endName: cached.endActor.name }
  }
  // Fallback: legacy PRNG (shown briefly until async load completes)
  const seed = dateToSeed(date)
  const rand = mulberry32(seed)
  const N = ACTOR_POOL.length
  const idxA = Math.floor(rand() * N)
  const idxB = (idxA + 1 + Math.floor(rand() * (N - 1))) % N
  return { startName: ACTOR_POOL[idxA].name, endName: ACTOR_POOL[idxB].name }
}

/**
 * Async version — resolves the correct chain-aware names from Firestore.
 * Used by HomeScreen to update once the Firestore data is loaded.
 */
export async function getDailyActorNamesAsync(dateStr) {
  const date = dateStr || getLocalDateStr()
  const puzzle = await getChainPuzzleForDate(date)
  return { startName: puzzle.startActor.name, endName: puzzle.endActor.name }
}

/**
 * Returns today's goal actor object { id, name, profile_path } for the
 * Today's Spotlight card on the HomeScreen.
 */
export async function getDailyGoalActorAsync(dateStr) {
  const date = dateStr || getLocalDateStr()
  const puzzle = await getChainPuzzleForDate(date)
  return puzzle.endActor // { id, name, profile_path }
}
